import React from 'react'

export type BaseLinkProps = React.PropsWithChildren<{ className?: string }>

type Props = BaseLinkProps & {
  href: string
}

export const BaseLink = ({ href, className = '', children }: Props) => (
  <a
    href={href}
    className={`mc-text--link ${className}`}
    target='_blank'
    rel='noopener noreferrer'
  >
    {children}
  </a>
)
